/* Treuespur - Konfigurator auf der Produktseite */
(function () {
  var MAX = 15 * 1024 * 1024;
  var EXT = ['.jpg', '.jpeg', '.png', '.heic', '.heif'];
  var $ = function (r, s) { return r.querySelector(s); };
  var $$ = function (r, s) { return [].slice.call(r.querySelectorAll(s)); };

  function extOk(n) {
    n = (n || '').toLowerCase();
    for (var i = 0; i < EXT.length; i++) if (n.slice(-EXT[i].length) === EXT[i]) return true;
    return false;
  }
  function bizDays(from, days) {
    var d = new Date(from.getTime()), a = 0;
    while (a < days) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) a++; }
    return d;
  }


  // Optimize large local photos during selection, never at checkout. The
  // original is always retained until Shopify accepts the final form.
  function prepareUploadPhoto(file) {
    if (!file || file.size < 1050 * 1024) return Promise.resolve(null);
    var jpeg = /^image\/jpeg$/i.test(file.type || '') || /\.jpe?g$/i.test(file.name || '');
    var heic = /^image\/hei[cf]$/i.test(file.type || '') || /\.hei[cf]$/i.test(file.name || '');
    var png = /^image\/png$/i.test(file.type || '') || /\.png$/i.test(file.name || '');
    if (!jpeg && !heic && !png) return Promise.resolve(null);
    function decode() {
      function fallback() {
        return new Promise(function (resolve, reject) {
          var url = URL.createObjectURL(file), image = new Image();
          image.onload = function () {
            URL.revokeObjectURL(url);
            resolve({ img: image, w: image.naturalWidth, h: image.naturalHeight });
          };
          image.onerror = function () { URL.revokeObjectURL(url); reject(new Error('Unsupported image')); };
          image.src = url;
        });
      }
      if (typeof createImageBitmap !== 'function') return fallback();
      return createImageBitmap(file).then(function (image) {
        return { img: image, w: image.width, h: image.height };
      }, fallback);
    }
    return decode().then(function (decoded) {
      if (!decoded.w || !decoded.h) return null;
      var scale = Math.min(1, 3000 / Math.max(decoded.w, decoded.h));
      var canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(decoded.w * scale));
      canvas.height = Math.max(1, Math.round(decoded.h * scale));
      var ctx = canvas.getContext('2d', { alpha: false });
      if (!ctx) { if (decoded.img.close) decoded.img.close(); return null; }
      // White matte preserves the visual appearance of transparent PNG
      // photographs rather than producing black transparency artifacts.
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(decoded.img, 0, 0, canvas.width, canvas.height);
      if (decoded.img.close) decoded.img.close();
      return new Promise(function (resolve) { canvas.toBlob(resolve, 'image/jpeg', .90); });
    }).then(function (blob) {
      if (!blob || blob.type !== 'image/jpeg' || blob.size >= file.size * .84) return null;
      var name = (heic || png) ? file.name.replace(/\.(hei[cf]|png)$/i, '.jpg') : file.name;
      return new File([blob], name, { type: 'image/jpeg', lastModified: file.lastModified });
    }).catch(function () { return null; });
  }

  class PPC extends HTMLElement {
    connectedCallback() {
      if (this._r) return;
      var pl = $(this, '[data-ppc-json]'), f = $(this, 'form');
      if (!pl || !f) return;
      this._r = true;

      this.d = JSON.parse(pl.textContent);
      this.form = f;
      this.photo = this.d.mode !== 'name_only';
      this.nameRequired = !!this.d.nameRequired;
      this.secondPhotoOptional = !!this.d.secondPhotoOptional;
      this.sel = (this.d.initial || []).slice();
      this.vid = $(this, '[data-ppc-variant-id]');
      this.price = $(this, '[data-ppc-price]');
      this.cmp = $(this, '[data-ppc-compare]');
      this.btn = $(this, '[data-ppc-submit]');
      this.btnLabel = $(this, '[data-ppc-submit-label]');
      this.check = $(this, '[data-ppc-checklist]');
      this.err = $(this, '[data-ppc-form-error]');
      this.deliv = $(this, '[data-ppc-delivery]');
      this.groups = $$(this, '[data-ppc-pet]');
      this.backEngravings = [];
      this.backIndex = 0;

      var cg = $(this, '[data-ppc-role="count"]');
      var colorGroup = $(this, '[data-ppc-role="color"]');
      this.countIdx = cg ? parseInt(cg.getAttribute('data-ppc-optgroup'), 10) : -1;
      this.colorIdx = colorGroup ? parseInt(colorGroup.getAttribute('data-ppc-optgroup'), 10) : 0;

      this.stripExpress();
      this.bindOpts();
      this.bindGalleryRestore();
      this.bindGuide();
      this.bindPhotoDialog();
      this.bindBackEngraving();
      this.bindGroups();
      f.addEventListener('submit', this.onSubmit.bind(this));
      this.renderDelivery();
      this.update(false);
    }

    stripExpress() {
      var self = this;
      ['.ppc-express', 'shopify-accelerated-checkout', '.shopify-payment-button', '[data-shopify="payment-button"]']
        .forEach(function (s) { $$(self, s).forEach(function (n) { n.remove(); }); });
    }

    bindOpts() {
      var self = this;
      this.addEventListener('click', function (event) {
        var b = event.target.closest('[data-ppc-val]');
        if (!b || !self.contains(b)) return;
        var i = parseInt(b.getAttribute('data-ppc-opt'), 10);
        self.sel[i] = b.getAttribute('data-ppc-val');
        self.update(true);
      });
      this.addEventListener('keydown', function (event) {
        var b = event.target.closest('[data-ppc-val]');
        if (!b || !self.contains(b)) return;
        var keys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
        if (keys.indexOf(event.key) < 0) return;
        var group = b.closest('[data-ppc-optgroup]');
        var buttons = $$(group, '[data-ppc-val]');
        var index = buttons.indexOf(b);
        var next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 1) + buttons.length) % buttons.length;
        event.preventDefault();
        buttons[next].click();
        buttons[next].focus();
      });
    }

    bindGalleryRestore() {
      var self = this;
      window.addEventListener('resize', function () {
        window.clearTimeout(self._galleryRestoreTimer);
        self._galleryRestoreTimer = window.setTimeout(function () {
          if (!self.isConnected) return;
          var v = self.variant();
          if (v) self.syncGallery(v.media, self.mediaKey(v));
        }, 180);
      }, { passive: true });
    }

    bindGuide() {
      var o = $(this, '[data-ppc-guide-open]'), dg = $(this, '[data-ppc-guide]');
      if (!o || !dg) return;
      o.addEventListener('click', function () { if (dg.showModal) dg.showModal(); else dg.setAttribute('open', ''); });
      $$(dg, '[data-ppc-guide-close]').forEach(function (b) {
        b.addEventListener('click', function () { if (dg.close) dg.close(); else dg.removeAttribute('open'); });
      });
      dg.addEventListener('click', function (e) { if (e.target === dg && dg.close) dg.close(); });
    }

    bindBackEngraving() {
      if (!this.d.backEngravingEnabled) return;
      var self = this;
      var dg = $(this, '[data-ppc-back-dialog]');
      var openers = $$(this, '[data-ppc-back-open]');
      if (!dg || !openers.length) return;

      this.backDialog = dg;
      this.backOpeners = openers;
      this.backLine1 = $(dg, '[data-ppc-back-line1]');
      this.backLine2 = $(dg, '[data-ppc-back-line2]');
      this.backCount1 = $(dg, '[data-ppc-back-count1]');
      this.backCount2 = $(dg, '[data-ppc-back-count2]');
      this.backError = $(dg, '[data-ppc-back-error]');
      this.backImage = $(dg, '[data-ppc-back-image]');
      this.backPreview1 = $(dg, '[data-ppc-back-preview1]');
      this.backPreview2 = $(dg, '[data-ppc-back-preview2]');

      var updatePreview = function () {
        var l1 = self.backLine1 ? self.backLine1.value : '';
        var l2 = self.backLine2 ? self.backLine2.value : '';
        if (self.backCount1) self.backCount1.textContent = l1.length + '/30';
        if (self.backCount2) self.backCount2.textContent = l2.length + '/10';
        if (self.backPreview1) {
          self.backPreview1.textContent = l1;
          self.backPreview1.hidden = !l1;
        }
        if (self.backPreview2) {
          self.backPreview2.textContent = l2;
          self.backPreview2.hidden = !l2;
        }
        if (self.backError) self.backError.hidden = true;
      };

      this.updateBackPreview = updatePreview;
      if (this.backLine1) this.backLine1.addEventListener('input', updatePreview);
      if (this.backLine2) this.backLine2.addEventListener('input', updatePreview);

      var close = function () {
        if (typeof dg.close === 'function') dg.close();
        else dg.removeAttribute('open');
      };

      openers.forEach(function (open) {
        open.addEventListener('click', function () {
          var idx = Math.max(0, (parseInt(open.getAttribute('data-ppc-back-index'), 10) || 1) - 1);
          self.backIndex = idx;
          var state = self.backEngravings[idx] || { line1: '', line2: '' };
          if (self.backLine1) self.backLine1.value = state.line1 || '';
          if (self.backLine2) self.backLine2.value = state.line2 || '';
          updatePreview();
          self.updateBackImage();
          var remove = $(dg, '[data-ppc-back-remove]');
          if (remove) remove.hidden = !(state.line1 || state.line2);
          if (typeof dg.showModal === 'function') dg.showModal();
          else dg.setAttribute('open', '');
          if (self.backLine1) setTimeout(function () { self.backLine1.focus(); }, 50);
        });
      });

      var x = $(dg, '[data-ppc-back-close]');
      if (x) x.addEventListener('click', close);
      dg.addEventListener('click', function (e) { if (e.target === dg) close(); });

      var apply = $(dg, '[data-ppc-back-apply]');
      if (apply) apply.addEventListener('click', function () {
        var l1 = self.backLine1 ? self.backLine1.value.trim() : '';
        var l2 = self.backLine2 ? self.backLine2.value.trim() : '';
        if (!l1 && !l2) {
          if (self.backError) self.backError.hidden = false;
          if (self.backLine1) self.backLine1.focus();
          return;
        }
        self.setBackEngraving(self.backIndex, l1, l2);
        close();
      });

      var remove = $(dg, '[data-ppc-back-remove]');
      if (remove) remove.addEventListener('click', function () {
        self.clearBackEngraving(self.backIndex);
        close();
      });

      this.updateBackImage();
    }

    setBackEngraving(index, line1, line2) {
      this.backEngravings[index] = { index: index + 1, line1: line1 || '', line2: line2 || '' };
      var open = this.backOpeners && this.backOpeners[index];
      if (!open) return;
      open.classList.add('is-active');
      var title = $(open, '[data-ppc-back-trigger-title]');
      var sub = $(open, '[data-ppc-back-trigger-sub]');
      if (title) title.textContent = 'Edit back engraving';
      if (sub) {
        var parts = [];
        if (line1) parts.push(line1);
        if (line2) parts.push(line2);
        sub.textContent = parts.join(' · ');
      }
      this.renderPrice();
      this.renderState(this.variant());
    }

    clearBackEngraving(index) {
      this.backEngravings[index] = null;
      var open = this.backOpeners && this.backOpeners[index];
      if (open) {
        open.classList.remove('is-active');
        var title = $(open, '[data-ppc-back-trigger-title]');
        var sub = $(open, '[data-ppc-back-trigger-sub]');
        if (title) title.textContent = 'Add back engraving';
        if (sub) sub.textContent = 'Add a personal message on the back';
      }
      if (this.backLine1) this.backLine1.value = '';
      if (this.backLine2) this.backLine2.value = '';
      if (this.updateBackPreview) this.updateBackPreview();
      if (this.backError) this.backError.hidden = true;
      this.renderPrice();
      this.renderState(this.variant());
    }

    activeBackEngravings() {
      var max = this.petCount();
      return this.backEngravings
        .slice(0, max)
        .filter(function (x) { return x && (x.line1 || x.line2); });
    }

    resetBackEngraving() {
      var self = this;
      this.backEngravings = [];
      (this.backOpeners || []).forEach(function (open, index) {
        open.classList.remove('is-active');
        var title = $(open, '[data-ppc-back-trigger-title]');
        var sub = $(open, '[data-ppc-back-trigger-sub]');
        if (title) title.textContent = 'Add back engraving';
        if (sub) sub.textContent = 'Add a personal message on the back';
      });
      if (this.backLine1) this.backLine1.value = '';
      if (this.backLine2) this.backLine2.value = '';
      if (this.backCount1) this.backCount1.textContent = '0/30';
      if (this.backCount2) this.backCount2.textContent = '0/10';
      if (this.updateBackPreview) this.updateBackPreview();
      if (this.backError) this.backError.hidden = true;
    }

    updateBackImage() {
      if (!this.backImage) return;
      var val = (this.sel[this.colorIdx] || '').toLowerCase();
      var src = this.backImage.getAttribute('data-gold');

      this.backImage.classList.remove('ppc-back-image--silver', 'ppc-back-image--rose');
      if (val.indexOf('silber') !== -1 || val.indexOf('silver') !== -1) {
        src = this.backImage.getAttribute('data-silver') || src;
        this.backImage.classList.add('ppc-back-image--silver');
      } else if (val.indexOf('ros') !== -1 || val.indexOf('rose') !== -1 || val.indexOf('pink') !== -1) {
        src = this.backImage.getAttribute('data-rose') || src;
        this.backImage.classList.add('ppc-back-image--rose');
      }

      if (src && this.backImage.getAttribute('src') !== src) this.backImage.setAttribute('src', src);
    }

    bindGroups() {
      var self = this;
      this.groups.forEach(function (g) {
        var file = $(g, '[data-ppc-file]');
        var name = $(g, '[data-ppc-name]');
        var cnt = $(g, '[data-ppc-counter]');

        if (name) {
          name.addEventListener('input', function () {
            if (name.value.length > name.maxLength) name.value = name.value.slice(0, name.maxLength);
            if (cnt) cnt.textContent = name.value.length + '/' + name.maxLength;
            self.update(false);
          });
        }

        if (!file) return;
        var drop = $(g, '[data-ppc-drop]');
        file.addEventListener('change', function () { self.accept(g, file.files && file.files[0]); });
        ['dragenter', 'dragover'].forEach(function (ev) {
          drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-dragging'); });
        });
        ['dragleave', 'drop'].forEach(function (ev) {
          drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-dragging'); });
        });
        drop.addEventListener('drop', function (e) {
          var fl = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
          if (!fl) return;
          try { var dt = new DataTransfer(); dt.items.add(fl); file.files = dt.files; } catch (x) { return; }
          self.accept(g, fl);
        });
        var ch = $(g, '[data-ppc-change]'), rm = $(g, '[data-ppc-remove]');
        if (ch) ch.addEventListener('click', function () { file.click(); });
        if (rm) rm.addEventListener('click', function () { file.value = ''; self.accept(g, null); });
      });
    }

    accept(g, file) {
      var error = $(g, '[data-ppc-error]'), preview = $(g, '[data-ppc-preview]'),
          idle = $(g, '[data-ppc-idle]'), loading = $(g, '[data-ppc-loading]'),
          img = $(g, '[data-ppc-thumb]'), loadingImg = $(g, '[data-ppc-loading-img]'),
          filename = $(g, '[data-ppc-filename]'), input = $(g, '[data-ppc-file]'),
          drop = $(g, '[data-ppc-drop]'), self = this;
      var token = (g._prepareToken || 0) + 1;
      g._prepareToken = token;
      g._optimizedFile = null;
      g._sourceFile = file || null;
      error.textContent = '';
      g.removeAttribute('aria-busy');
      drop.classList.remove('is-loading', 'is-ready');
      if (g._reader && g._reader.readyState === 1) {
        try { g._reader.abort(); } catch (ignore) {}
      }
      if (g._progressTimer) window.clearInterval(g._progressTimer);
      if (g._finishTimer) window.clearTimeout(g._finishTimer);
      g._reader = null;
      g._progressTimer = g._finishTimer = null;
      if (g._url) { URL.revokeObjectURL(g._url); g._url = null; }
      if (!file) {
        loading.hidden = true;
        preview.hidden = true;
        idle.hidden = false;
        img.removeAttribute('src');
        loadingImg.removeAttribute('src');
        return this.update(false);
      }
      if (!extOk(file.name) || file.size > MAX) {
        input.value = '';
        loading.hidden = true;
        preview.hidden = true;
        idle.hidden = false;
        error.textContent = file.size > MAX
          ? 'This photo is too large. Please choose a file up to 15 MB.'
          : 'This file format is not supported. Please use JPG, PNG or HEIC.';
        return this.update(false);
      }
      g._url = URL.createObjectURL(file);
      img.hidden = false;
      loadingImg.hidden = false;
      img.onerror = function () { img.hidden = true; };
      loadingImg.onerror = function () { loadingImg.hidden = true; };
      img.src = g._url;
      loadingImg.src = g._url;
      if (filename) filename.textContent = file.name;
      idle.hidden = true;
      preview.hidden = false;
      loading.hidden = true;
      g.setAttribute('aria-busy', 'true');
      drop.classList.add('is-ready');
      this.renderState(this.variant());
      function ready(result) {
        if (token !== g._prepareToken || g._sourceFile !== file) return;
        g._optimizedFile = result || null;
        loading.hidden = true;
        preview.hidden = false;
        g.removeAttribute('aria-busy');
        drop.classList.remove('is-loading');
        drop.classList.add('is-ready');
        self.update(false);
      }
      // When this is already a small PNG/JPEG, reveal the image immediately.
      g._preparing = prepareUploadPhoto(file).then(ready, function () { ready(null); });
    }

    money(cents) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: this.d.currency || 'EUR' }).format(cents / 100);
    }

    totalCents(v) {
      if (!v) return 0;
      return Number(v.priceCents) + this.activeBackEngravings().length * Number(this.d.backPriceCents || 990);
    }

    compareTotalCents(v) {
      if (!v || Number(v.compareCents) <= Number(v.priceCents) || !Number(v.compareCents)) return 0;
      return Number(v.compareCents) + (this.totalCents(v) - Number(v.priceCents));
    }

    renderPrice() {
      var v = this.variant();
      if (!v) return;
      var count = this.activeBackEngravings().length;
      if (this.price) this.price.textContent = this.money(this.totalCents(v));
      var inlinePrice = $(this, '[data-ptk-inline-price]');
      var referenceTotal = this.compareTotalCents(v);
      if (this.cmp) {
        this.cmp.hidden = !referenceTotal;
        this.cmp.textContent = referenceTotal ? this.money(referenceTotal) : '';
      }
      var saving = inlinePrice && $(inlinePrice, '[data-ptk-inline-saving]');
      if (saving) {
        saving.hidden = !referenceTotal;
        var percent = referenceTotal ? Math.round((referenceTotal - this.totalCents(v)) * 100 / referenceTotal) : 0;
        saving.textContent = inlinePrice.getAttribute('data-save-template').replace('__PERCENT__', percent);
      }
      var summary = $(this, '[data-ppc-total-summary]');
      if (summary) {
        summary.textContent = count ? count + ' ' + (count === 1 ? this.d.backOneLabel : this.d.backManyLabel) : '';
        summary.parentElement.hidden = !count;
      }
      var self = this;
      $$(this, '[data-ppc-role="count"] [data-ppc-val]').forEach(function (button) {
        var selected = self.sel.slice();
        selected[self.countIdx] = button.getAttribute('data-ppc-val');
        var candidate = self.d.variants.find(function (option) { return option.opts.every(function (value, index) { return value === selected[index]; }); });
        var label = $(button, '[data-ppc-count-price]');
        if (label) label.textContent = candidate ? self.money(candidate.priceCents) : '';
        var compare = $(button, '[data-ppc-count-compare]');
        if (compare) {
          var showCompare = candidate && Number(candidate.compareCents) > Number(candidate.priceCents);
          compare.hidden = !showCompare;
          compare.textContent = showCompare ? self.money(candidate.compareCents) : '';
        }
        var preview = $(button, '.ppc-count__image');
        if (preview && candidate && candidate.image) {
          if (preview.getAttribute('src') !== candidate.image) {
            preview.removeAttribute('srcset');
            preview.src = candidate.image;
          }
        }
      });
    }

    variant() {
      var s = this.sel;
      for (var i = 0; i < this.d.variants.length; i++) {
        var v = this.d.variants[i], ok = true;
        for (var j = 0; j < s.length; j++) if (v.opts[j] !== s[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }

    petCount() {
      if (this.countIdx < 0) return this.d.maxPets || 1;
      return parseInt(this.sel[this.countIdx], 10) || 1;
    }

    update(colorChanged) {
      var self = this;
      $$(this, '[data-ppc-optgroup]').forEach(function (fs) {
        var i = parseInt(fs.getAttribute('data-ppc-optgroup'), 10);
        $$(fs, '[data-ppc-val]').forEach(function (b) {
          var on = b.getAttribute('data-ppc-val') === self.sel[i];
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
        });
        var lv = $(fs, '[data-ppc-optvalue]');
        if (lv) {
          var selectedButton = $(fs, '[data-ppc-val].is-active');
          lv.textContent = selectedButton ? (selectedButton.getAttribute('title') || self.sel[i] || '') : (self.sel[i] || '');
        }
      });

      var want = this.petCount();
      var multiNote = this.querySelector('[data-ppc-multi-note]');
      if (multiNote) {
        multiNote.hidden = want < 2;
        multiNote.textContent = this.secondPhotoOptional
          ? 'You can upload up to ' + want + ' photos. The second photo is optional.'
          : 'You have selected ' + want + ' portraits. Please upload a separate photo for each portrait.';
      }
      this.groups.forEach(function (g, i) {
        var on = i < want;
        g.hidden = !on;
        $$(g, 'input').forEach(function (inp) { inp.disabled = !on; });
      });

      var v = this.variant();
      if (v) {
        this.vid.value = v.id;
        if (this.price) this.price.innerHTML = v.price;
        if (this.cmp) {
          if (v.compare) { this.cmp.innerHTML = v.compare; this.cmp.hidden = false; }
          else { this.cmp.textContent = ''; this.cmp.hidden = true; }
        }
        if (colorChanged) {
          var gallery = (this.closest('.shopify-section') || document).querySelector('media-gallery');
          if (gallery && gallery.dataset.treuespurCurated === 'true' && typeof gallery.refreshVariant === 'function') {
            gallery.refreshVariant(v.id).then(function (updated) {
              if (!updated && self.isConnected && self.variant() && self.variant().id === v.id) {
                self.syncGallery(v.media, self.mediaKey(v));
              }
            });
          } else {
            this.syncGallery(v.media, this.mediaKey(v));
          }
          if (window.location.pathname.indexOf('/products/') !== -1) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url.toString());
          }
        }
      }
      this.updateBackImage();
      this.renderPrice();
      this.renderState(v);
    }

    missing() {
      var out = [], want = this.petCount(), multi = want > 1;
      for (var i = 0; i < want; i++) {
        var g = this.groups[i];
        if (!g) continue;
        var f = $(g, '[data-ppc-file]'), n = $(g, '[data-ppc-name]');
        var l = multi ? 'pet ' + (i + 1) : 'your pet';
        if (this.photo && f && (!f.files || !f.files.length) && !(this.secondPhotoOptional && i === 1)) out.push('Photo for ' + l);
        if (this.nameRequired && n && !n.value.trim()) out.push('Name for ' + l);
      }
      return out;
    }

    renderState(v) {
      if (this._busy) return;
      var miss = this.missing(), out = !v || !v.available;
      var preparing = this.groups.some(function (g) { return g.getAttribute('aria-busy') === 'true'; });
      var ready = !miss.length && !out && !preparing;
      this.btn.disabled = out || preparing;
      this.btn.classList.remove('is-busy');
      this.btnLabel.textContent = preparing ? 'Preparing photo …' : (out ? 'Currently unavailable' : (miss.length ? this.d.incompleteLabel : this.d.readyLabel));
      if (!preparing && !out) this.btnLabel.textContent += ' · ' + this.money(this.totalCents(v));
      var buttonCompare = $(this, '[data-ppc-submit-compare]');
      if (buttonCompare) {
        var referenceTotal = !preparing && !out ? this.compareTotalCents(v) : 0;
        var showCompare = referenceTotal > 0;
        buttonCompare.hidden = !showCompare;
        buttonCompare.textContent = showCompare ? this.money(referenceTotal) : '';
      }
      if (!this.check) return;
      if (preparing || out || !miss.length) { this.check.hidden = true; this.check.textContent = ''; }
      else { this.check.hidden = false; this.check.textContent = 'Still needed to continue: ' + miss.join(', ') + '.'; }
    }

    bindPhotoDialog() {
      this.photoDialog = $(this, '[data-ppc-photo-dialog]');
      var dg = this.photoDialog;
      if (!dg) return;
      var self = this;
      var close = function () { if (dg.close) dg.close(); else dg.removeAttribute('open'); };
      var x = $(dg, '[data-ppc-photo-close]');
      if (x) x.addEventListener('click', close);
      dg.addEventListener('click', function (e) { if (e.target === dg) close(); });
      var upload = $(dg, '[data-ppc-photo-upload]');
      if (upload) upload.addEventListener('click', function () {
        var file = self.firstMissingPhoto();
        close();
        if (file) {
          file.scrollIntoView({ behavior: 'smooth', block: 'center' });
          file.click();
        }
      });
    }

    firstMissingPhoto() {
      if (!this.photo) return null;
      var want = this.petCount();
      for (var i = 0; i < want; i++) {
        if (this.secondPhotoOptional && i === 1) continue;
        var g = this.groups[i], file = g && $(g, '[data-ppc-file]');
        if (file && (!file.files || !file.files.length)) return file;
      }
      return null;
    }

    mediaKey(v) {
      if (!v || !v.opts) return '';
      var handle = this.d.handle || '';
      var color = String(v.opts[this.colorIdx] || v.opts[0] || '').toLowerCase();
      var count = String(this.countIdx >= 0 ? v.opts[this.countIdx] : (v.opts[1] || '1'));

      if (handle === 'tierportraet-kette-foto-name' || handle === 'haustier-portrat-kette' || handle === 'personalized-pet-portrait-necklace') {
        if (color === 'gold' || (color.indexOf('vergoldet') !== -1 && color.indexOf('ros') === -1) || (color.indexOf('gold plated') !== -1 && color.indexOf('rose') === -1)) return ({ '1': 'n01.', '2': 'n02.', '3': 'n03.', '4': 'n04.' })[count] || 'n01.';
        if (color === 'silber' || color === 'silver') return ({ '1': 'n05.', '2': 'n06.', '3': 'n07.', '4': 'n08.' })[count] || 'n05.';
        if (color.indexOf('ros') === 0 || color.indexOf('rose') !== -1) return 'n09.';
      }

      if (handle === 'tierportraet-armband-foto-name' || handle === 'haustier-portrat-armband' || handle === 'personalized-pet-portrait-bracelet') {
        if (color === 'gold' || (color.indexOf('vergoldet') !== -1 && color.indexOf('ros') === -1) || (color.indexOf('gold plated') !== -1 && color.indexOf('rose') === -1)) return 'b01.';
        if (color === 'silber' || color === 'silver') return 'b02.';
        if (color.indexOf('ros') === 0 || color.indexOf('rose') !== -1) return 'b03.';
      }

      if (handle === 'tierportraet-schluesselanhaenger-foto' || handle === 'haustier-portrat-schlusselanhanger' || handle === 'personalized-pet-portrait-keychain') {
        if (color === 'gold' || (color.indexOf('vergoldet') !== -1 && color.indexOf('ros') === -1) || (color.indexOf('gold plated') !== -1 && color.indexOf('rose') === -1)) return count === '2' ? 's04_' : 'c01.';
        if (color === 'silber' || color === 'silver') return 's01_';
        if (color.indexOf('ros') === 0 || color.indexOf('rose') !== -1) return 'c03.';
      }

      return '';
    }

    syncGallery(mediaId, mediaKey) {
      var sc = this.closest('.shopify-section') || document;
      var gallery = sc.querySelector('media-gallery');
      if (!gallery) return;

      var slideshow = gallery.querySelector('slideshow-component[ref="slideshow"]');
      var root = slideshow || gallery;
      var e = null;

      if (mediaId) {
        e = root.querySelector(`[data-media-id='${mediaId}']`) || root.querySelector(`[data-media-id$='-${mediaId}']`);
      }

      if (!e && mediaKey) {
        var key = mediaKey.toLowerCase();
        e = [].slice.call(root.querySelectorAll('slideshow-slide img')).find(function (img) {
          return String(img.currentSrc || img.getAttribute('src') || '').toLowerCase().indexOf(key) !== -1;
        }) || null;
      }

      var slide = e && e.closest('slideshow-slide');
      if (slide && slideshow && typeof slideshow.select === 'function') {
        var slides = [].slice.call(slideshow.querySelectorAll('slideshow-slide[ref="slides[]"]'));
        var index = slides.indexOf(slide);
        if (index >= 0) {
          slideshow.select(index, undefined, { animate: false });
          return;
        }
      }

      if (e && e.scrollIntoView) e.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    renderDelivery() {
      if (!this.deliv) return;
      this.deliv.textContent = 'Delivery varies by destination';
    }

    busy(on) {
      this._busy = on;
      this.btn.disabled = on;
      this.btn.classList.toggle('is-busy', on);
      if (on) {
        this.btnLabel.textContent = 'Adding to cart …';
        var buttonCompare = $(this, '[data-ppc-submit-compare]');
        if (buttonCompare) buttonCompare.hidden = true;
        if (!$(this.btn, '.ts-spin')) {
          var s = document.createElement('span');
          s.className = 'ts-spin';
          this.btn.insertBefore(s, this.btn.firstChild);
        }
      } else {
        var sp = $(this.btn, '.ts-spin');
        if (sp) sp.remove();
      }
    }

    addBackEngraving(baseBody) {
      var engravings = this.activeBackEngravings();
      if (!engravings.length) return Promise.resolve(baseBody);

      var payload = {
        items: engravings.map(function (engraving) {
          return {
            id: Number(this.d.backEngravingVariantId),
            quantity: 1,
            properties: {
              'For pendant': String(engraving.index),
              'Line 1': engraving.line1 || '',
              'Line 2': engraving.line2 || '',
              '_treuespur_font': '22',
              '_treuespur_addon': 'back-engraving',
              '_treuespur_bogo_exclude': 'true',
              '_treuespur_parent_key': (baseBody && baseBody.key) ? baseBody.key : ''
            }
          };
        }, this)
      };
      if (window.TSG && window.TSG.sectionId) payload.sections = window.TSG.sectionId;

      return fetch(this.d.addUrl + '.js', {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (res.ok) return res.body;
          var message = res.body.description || res.body.message || 'Could not add the back engraving.';
          if (!baseBody || !baseBody.key) throw new Error(message);
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          return fetch(root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: baseBody.key, quantity: 0 })
          }).catch(function () {}).then(function () { throw new Error(message); });
        });
    }

    // Shopify kann in einzelnen Sessions einen Warenkorb-Artikel irreführend
    // als ausverkauft melden. Nie blind ein zweites Mal hinzufügen:
    // zunächst anhand der eindeutigen Anfrage-ID im tatsächlichen Warenkorb prüfen.
    cartSnapshot() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (response) {
          if (!response.ok) throw new Error('Could not verify your cart.');
          return response.json();
        });
    }

    recoverCartItem(requestId, variantId) {
      var self = this;
      return this.cartSnapshot().then(function (cart) {
        var matched = (cart.items || []).some(function (item) {
          return String(item.variant_id) === String(variantId) &&
            String((item.properties || {})._treuespur_upload_request || '') === requestId;
        });
        if (!matched) return null;
        var cartPath = self.d.cartUrl || '/cart';
        var join = cartPath.indexOf('?') === -1 ? '?' : '&';
        return fetch(cartPath + join + 'sections=' + encodeURIComponent(window.TSG ? window.TSG.sectionId : 'treuespur-cart-drawer'), {
          credentials: 'same-origin', cache: 'no-store'
        }).then(function (response) {
          if (!response.ok) throw new Error('Could not load the cart.');
          return response.json();
        }).then(function (sections) {
          return { sections: sections };
        });
      });
    }

    // Einmaliger direkter Shopify-Request, ohne das globale Warenkorb-Fetch-
    // Intercept. Nur für Foto-Produkte OHNE kostenpflichtige Rückgravur:
    // diese benötigt die reguläre Zuordnungslogik und darf nicht umgangen werden.
    directCartAdd(formData) {
      var url = this.d.addUrl + '.js';
      return new Promise(function (resolve, reject) {
        var request = new XMLHttpRequest();
        request.open('POST', url, true);
        request.timeout = 30000;
        request.setRequestHeader('Accept', 'application/javascript');
        request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        request.onload = function () {
          var data = {};
          try { data = JSON.parse(request.responseText || '{}'); } catch (ignore) {}
          if (request.status >= 200 && request.status < 300) resolve(data);
          else {
            var issue = new Error(data.description || data.message || 'Could not add this product to the cart.');
            issue.httpStatus = request.status;
            reject(issue);
          }
        };
        request.onerror = function () { reject(new Error('Could not connect to the shop. Please try again.')); };
        request.ontimeout = function () { reject(new Error('The connection timed out. Please try again.')); };
        request.send(formData);
      });
    }

    onSubmit(ev) {
      ev.preventDefault();
      if (this.btn.disabled || this._busy) return;
      var file = this.firstMissingPhoto();
      if (file) {
        if (this.photoDialog) {
          var photoIndex = this.groups.findIndex(function (group) { return group.contains(file); }) + 1;
          var multiPhoto = this.petCount() > 1;
          var photoTitle = $(this.photoDialog, '[data-ppc-photo-title]');
          var photoDescription = $(this.photoDialog, '[data-ppc-photo-desc]');
          if (photoTitle) photoTitle.textContent = multiPhoto ? 'Photo for pet ' + photoIndex + ' is still missing' : 'Your pet photo is still missing';
          if (photoDescription) photoDescription.textContent = (multiPhoto ? 'Please upload a photo for pet ' + photoIndex + '.' : 'Please upload a photo for your keepsake.') + ' We review your photo before production and contact you if another image is needed.' + (this.nameRequired ? '' : ' Adding a name is optional.');
          if (this.photoDialog.showModal) this.photoDialog.showModal();
          else this.photoDialog.setAttribute('open', '');
        } else {
          file.scrollIntoView({ behavior: 'smooth', block: 'center' });
          file.click();
        }
        return;
      }
      var missing = this.missing();
      if (missing.length) {
        this.err.textContent = 'Still needed to continue: ' + missing.join(', ') + '.';
        this.err.hidden = false;
        var name = $(this.groups[0], '[data-ppc-name]');
        if (name) name.focus();
        return;
      }
      var self = this;
      var waiting = this.groups.filter(function (group) {
        return !group.hidden && group._preparing && group.hasAttribute('aria-busy');
      }).map(function (group) { return group._preparing; });

      this.err.hidden = true;
      this.err.textContent = '';
      this.busy(true);
      if (window.TSG && window.TSG.beginAdd) window.TSG.beginAdd();

      function sendToShopify() {
        // Always build FormData AFTER the brief background preparation period.
        // The actual file inputs stay untouched; optimized JPEGs replace
        // only their multipart body, not the ordered personalization fields.
        var fd = new FormData(self.form);
        self.groups.forEach(function (group) {
          if (group.hidden) return;
          var field = $(group, '[data-ppc-file]');
          if (field && field.files && field.files[0] && field.name &&
              group._optimizedFile && group._sourceFile === field.files[0]) {
            fd.set(field.name, group._optimizedFile, group._optimizedFile.name);
          }
        });
        fd.set('id', self.vid.value);
        // Einmalige Kennung, damit auch bei einer fehlerhaften Shopify-Antwort
        // bereits hinzugefügte Positionen erkannt werden (kein Doppel-Add).
        var requestId = (window.crypto && window.crypto.randomUUID)
          ? window.crypto.randomUUID()
          : 'ts-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
        fd.set('properties[_treuespur_upload_request]', requestId);
        fd.append('properties[_treuespur_personalized]', 'true');
        if (!fd.get('properties[_treuespur_back_engravings]')) {
          var selectedBacks = self.activeBackEngravings();
          if (selectedBacks.length) fd.set('properties[_treuespur_back_engravings]', JSON.stringify(selectedBacks));
        }
        if (window.TSG) fd.append('sections', window.TSG.sectionId);
        fd.set('sections_url', self.d.cartUrl || '/cart');

        fetch(self.d.addUrl + '.js', {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        }).then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, status: response.status, body: data };
          });
        }).then(function (result) {
          if (result.ok) return result.body;

          var description = String(result.body.description || result.body.message || '');
          var soldOut = /ausverkauft|sold out|out of stock/i.test(description);
          var hasPaidBack = self.activeBackEngravings().length > 0;

          if (result.status !== 422 || !soldOut || hasPaidBack || !self.photo) {
            throw new Error(description || 'This product could not be added to the cart.');
          }

          // 422 bedeutet nicht zwingend, dass der Artikel NICHT im Warenkorb
          // angekommen ist. Vor dem einmaligen Fallback den Cart lesen.
          return self.recoverCartItem(requestId, self.vid.value).then(function (alreadyAdded) {
            if (alreadyAdded) return alreadyAdded;
            return self.directCartAdd(fd);
          });
        }).then(function (added) {
          // Erst nach bestätigtem Shopify-Erfolg Personalisierung zurücksetzen.
          self.busy(false);
          self.reset();
          if (window.TSG) return window.TSG.afterFirstAdd(added);
          window.location.href = self.d.cartUrl;
        }).catch(function (error) {
          self.busy(false);
          var rawMessage = String(error && error.message || '');
          var staleStockMessage = /ausverkauft|sold out|out of stock/i.test(rawMessage) &&
            self.variant() && self.variant().available;
          // Kein falsches "ausverkauft", wenn Shopify die laut Produktseite
          // verfügbare Variante trotz sicherem Retry zurückweist.
          self.err.textContent = staleStockMessage
            ? 'Your keepsake could not be added right now. Please reload the page and try again.'
            : (rawMessage || 'The photo upload failed.');
          self.err.hidden = false;
          if (window.TSG && window.TSG.addFailed) window.TSG.addFailed(error);
          self.renderState(self.variant());
        });
      }

      // If compression is still running because the customer clicked very
      // quickly, wait at most 1.4 seconds. This often prevents uploading
      // several megabytes of raw image unnecessarily on mobile connections.
      // On browser issues, fall back to the real original immediately.
      if (waiting.length) {
        Promise.race([
          Promise.all(waiting.map(function (p) {
            return Promise.resolve(p).catch(function () { return null; });
          })),
          new Promise(function (resolve) { window.setTimeout(resolve, 1400); })
        ]).then(sendToShopify, sendToShopify);
      } else {
        sendToShopify();
      }
    }

    reset() {
      var self = this;
      this.groups.forEach(function (g) {
        var f = $(g, '[data-ppc-file]'), n = $(g, '[data-ppc-name]'), c = $(g, '[data-ppc-counter]');
        if (f) { f.value = ''; self.accept(g, null); }
        if (n) n.value = '';
        if (c && n) c.textContent = '0/' + n.maxLength;
      });
      this.resetBackEngraving();
      this.update(false);
    }
  }

  if (!customElements.get('pet-portrait-configurator')) {
    customElements.define('pet-portrait-configurator', PPC);
  }
})();









